import fetchApi from 'services/api/connector';

export const save = (data) => fetchApi('preferences', { method: 'POST', data });
export const fetch = () => fetchApi('preferences', { method: 'GET' });
